import { createQueryKeys } from '@lukemorales/query-key-factory'
import { Widget } from '@organization/models'

import { mainAxios } from './axios/mainAxios'

export const dashboard = {
  getWidgetsById: async (id?: number) => {
    const { data } = await mainAxios.get<Widget[]>(`/dashboard/widgets/${id}`)

    return data
  }
}

export const dashboardQuery = createQueryKeys('dashboard', {
  getWidgetsById: (id?: number) => ({
    queryKey: [id],
    queryFn: () => dashboard.getWidgetsById(id)
  })
})
